import React from 'react';

import { Body2 } from '@cian/ui-kit';
import { IconFunctionalHelpCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { NBSP } from 'shared/constants/common';
import { ETestIds } from 'shared/constants/testIds';

import styles from './styles.css';

export interface IProgramCardTermHint {
  content: React.ReactNode;
  tooltip: React.ReactNode;
}

export const FamilyLoanAmountHintContent: React.FC = () => (
  <div className={styles['term-hint']} data-testid={ETestIds.FamilyLoanAmountHint}>
    <span className={styles['term-hint-text']}>влияет число детей</span>
    <span className={styles['term-hint-icon']}>
      <IconFunctionalHelpCircle16 color="icon-primary-default" />
    </span>
  </div>
);

export const FamilyLoanAmountHintTooltip: React.FC = () => (
  <div className={styles['hint-tooltip']} data-testid={ETestIds.FamilyLoanAmountHintTooltip}>
    <Body2>{`Лимит зависит от количества детей и${NBSP}региона:`}</Body2>
    <ul className={styles['hint-tooltip-list']}>
      <li>
        <Body2>{`1 ребёнок — до 6 млн ₽ в регионах / до${NBSP}12 млн ₽ в Москве и МО, Санкт-Петербурге и ЛО;`}</Body2>
      </li>
      <li>
        <Body2>2 ребёнка — до 8 млн ₽ / до 15 млн ₽;</Body2>
      </li>
      <li>
        <Body2>{`3 и более детей — до 10 млн ₽ / до${NBSP}18${NBSP}млн ₽`}</Body2>
      </li>
    </ul>
  </div>
);

export const familyLoanAmountHint: IProgramCardTermHint = {
  content: <FamilyLoanAmountHintContent />,
  tooltip: <FamilyLoanAmountHintTooltip />,
};
